export default __webpack_public_path__ + "static/media/img4.d0b2ccad.svg";